import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRankConfig = createAsyncThunk(
  'crossroompkUndertake/getRankConfig',
  async (e, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/live/commonactivity/get_cross_room_pk_config',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data
  }
)
export const getRankInfo = createAsyncThunk(
  'crossroompkUndertake/getRankInfo',
  async (params: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/live/commonactivity/get_cross_room_pk_list',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data
  }
)
interface itemProp {
  member_info: {
    ext_data: {
      icon: string
    }
    name: string
    avatar: string
    id: any
    sub_list: any[] | null
    zy_id: string
  }
  score: number
  rank: number
}
const initialState: {
  count_down: number
  activity_id: number
  offset: number
  more: boolean
  activity_type: number
  own: itemProp
  list: itemProp[]
} = {
  count_down: 0,
  activity_id: 0,
  offset: 0,
  more: false,
  activity_type: 3,
  own: {} as any,
  list: [],
}

export const rankTastSlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRankConfig.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getRankInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})
export default rankTastSlice.reducer
